/* tslint:disable */
/* eslint-disable */

import { ConcreteRequest } from "relay-runtime";
export type useFeatureFlagQueryVariables = {
    name: string;
};
export type useFeatureFlagQueryResponse = {
    readonly featureFlag: {
        readonly name: string;
        readonly enabled: boolean;
    } | null;
};
export type useFeatureFlagQuery = {
    readonly response: useFeatureFlagQueryResponse;
    readonly variables: useFeatureFlagQueryVariables;
};



/*
query useFeatureFlagQuery(
  $name: String!
) {
  featureFlag(name: $name) {
    name
    enabled
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "concreteType": "FeatureFlag",
    "kind": "LinkedField",
    "name": "featureFlag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFeatureFlagQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFeatureFlagQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e1f73627802f5a003c3261cb3963b495",
    "id": null,
    "metadata": {},
    "name": "useFeatureFlagQuery",
    "operationKind": "query",
    "text": "query useFeatureFlagQuery(\n  $name: String!\n) {\n  featureFlag(name: $name) {\n    name\n    enabled\n  }\n}\n"
  }
};
})();
(node as any).hash = '8a4cd86c6ee5629cfe940292a61de977';
export default node;
